import React from "react";
import { ThemeProvider } from "styled-components";
import { DefaultTheme, EinsteinTheming } from "@mindsight/einstein";
import { AxiosSettingsAPI } from "../common/Api";
import { useAsync } from "react-async";

export const Theming = ({ children, configProviderProps }) => {
  const { data, isPending, error } = useAsync({
    promiseFn: AxiosSettingsAPI.getAll,
  });

  const getElementByKey = (key) => {
    if (!isPending && !error) {
      const result = data.find((element) => element.key === key);
      if (result) return result.value;
    }
  };

  const primaryColor = getElementByKey("PRIMARY_COLOR");
  const secondaryColor = getElementByKey("SECONDARY_COLOR");

  return (
    <EinsteinTheming
      theme={{
        primaryColor: primaryColor || DefaultTheme.primaryColor,
        secondaryColor: secondaryColor || DefaultTheme.secondaryColor,
      }}
      configProviderProps={configProviderProps}
    >
      <ThemeProvider
        theme={{
          primary: primaryColor || "#0A414F",
          secondary: secondaryColor || "#D99C2B",
        }}
      >
        {children}
      </ThemeProvider>
    </EinsteinTheming>
  );
};
